import Container from "../ProductDetailsStyle";
import Spinner from "../../../shared/Spinner/Spinner";
import api from "../../../services/api";
import AuthContext from "../../../contexts/authContext";

import { useContext, useEffect, useState } from "react";
import { AxiosRequestConfig } from "axios";
import { ProgressBar } from "react-bootstrap";
import InfoModal from "../../../shared/Bootstrap/InfoModal";
import PageTitle from "../../../components/PageTitle";
import { GetFileFromURL } from "../../../utils";
import { InputImage } from "../../../components/InputImage/InputImage";


export default function VariationProductGroupDetails(props) {

  const { userData } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [errorEditing, setErrorEditing] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");


  const [name, setName] = useState("");
  const [color, setColor] = useState("#ffffff");
  const [productCompanyId, setProductCompanyId] = useState(0);
  const [textureUrl, setTextureUrl] = useState("");

  const [selectedTextureFile, setSelectedTextureFile] = useState({} as File);
  const [isTextureFilePicked, setIsTextureFilePicked] = useState(false);
  const [uploadingTextureFile, setUploadingTextureFile] = useState(false);
  const [uploadTexturePercentage, setUploadTexturePercentage] = useState(0);

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);


  const productId = parseInt(props.match?.params?.productId);
  const variationId = parseInt(props.match?.params?.variationId) || 0;
  const groupId = parseInt(props.match?.params?.groupId) || 0;
  const creatingNew = groupId <= 0;

  useEffect(() => {
    if (!creatingNew)
      LoadGroup();
  }, []);

  async function LoadGroup() {
    try {
      setLoading(true);
      const result = await api.get(`variationGroups/${groupId}`);
      if (result.data.success) {
        const groupData = result.data.groupData;
        SetGroup(groupData);
      }
      else
        console.error("Não pode pegar os dados do grupo: ", result.data);
    }
    catch (error) {
      console.error("Erro pegando dados do grupo: ", error);
      setErrorMessage("Não foi possível carregar dados do grupo");
    }
    finally {
      setLoading(false);
    }
  }

  function SetGroup(groupData) {
    setName(groupData.name);
    setColor(groupData.color || "#FFFFFF");
    setProductCompanyId(groupData.companyId);
    setTextureUrl(groupData.materialUrl);
  }

  function ChangeFileSelected(event) {
    const file = event.target.files[0];
    setSelectedTextureFile(file);
    setIsTextureFilePicked(file !== undefined);
  };

  function GetTextureURL(): string {
    console.log("Buscando textura de URL: " + textureUrl);
    return GetFileFromURL(textureUrl, `${process.env.REACT_APP_BASE_URL}/variationGroups/${groupId}/texture`);
  }

  async function OnSubmit() {
    try {
      setLoading(true);

      const options: AxiosRequestConfig = {};
      const formData = new FormData();

      if (isTextureFilePicked) {
        formData.append("texture", selectedTextureFile, selectedTextureFile.name);
        setUploadingTextureFile(true);
        options.onUploadProgress = progressEvent => {
          const { loaded, total } = progressEvent;
          const percentage = Math.floor(loaded * 100 / total);
          setUploadTexturePercentage(percentage);
          console.log(`${loaded / 1024}kb of ${total / 1024}kb | ${percentage}% Material uploaded`);
        }
      }
      else
        formData.append("textureUrl", textureUrl);

      formData.append("name", name);
      if (color !== "")
        formData.append("color", color);

      const request = await (
        creatingNew ?
          api.post(`/products/${productId}/${variationId}`, formData, options)
          : api.put(`/products/${productId}/${variationId}/${groupId}`, formData, options)
      );

      setErrorEditing(false);
      setLoading(false);
      setUploadingTextureFile(false);
      setIsTextureFilePicked(false);
      const success = request.data.success
      if (creatingNew && success)
        goBack();
      else if (success)
        setShowSuccessPopup(true);
    }
    catch (error: any) {
      setErrorEditing(true);
      setLoading(false);
      setErrorMessage(error?.response?.data?.message || "Não foi possível editar grupo de variação");
    }
  }


  function goBack() {
    props.history.goBack();
  }

  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title="Variação de grupo editado com sucesso!"
        body="Suas edições foram salvas com sucesso"
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    )
  }

  const disabled = loading || (productCompanyId !== userData.companyId && !creatingNew);

  return (
    <Container>
      <PageTitle title="Detalhes do Grupo de Variação" />
      {ShowSuccessPopup()}
      <div className="productDetails">
        <div>
          <button onClick={() => goBack()} className="btn btn-secondary">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorEditing && <p className="alert alert-error">Erro: {errorMessage}</p>}
        <main>
          <div className="panel">
            <form className="main-form" id="variationGroupDetailsForm" onSubmit={
              (e) => {
                e.preventDefault();
                OnSubmit();
              }}>
              <div id="header">
                <h2>{creatingNew ? "Criar" : "Editar"} grupo de variação</h2>
              </div>
              <div>
                <label>Grupo:</label>
                <input

                  autoComplete="product-name"
                  disabled={disabled}
                  value={name || ""}
                  onChange={e => setName(e.target.value)}
                />
              </div>

              <div>
                <label>Cor:</label>
                <input

                  autoComplete="product-name"
                  type="color"
                  disabled={disabled}
                  value={color}
                  placeholder="#000000"
                  onChange={e => setColor(e.target.value)}
                />
              </div>

              <div>
                <label>Url:</label>
                <input
                  type="url"
                  autoComplete="off"
                  disabled={disabled || Boolean(selectedTextureFile?.name)}
                  value={textureUrl}
                  onChange={e => setTextureUrl(e.target.value)} />
              </div>
              <div>
                <label>Textura:</label>
                <InputImage
                  id="file"
                  name="file"
                  label=""
                  alt="Imagem do produto"
                  acceptedMimeTypes="image/png, image/jpeg"
                  imageUrl={GetTextureURL()}
                  disabled={disabled || uploadingTextureFile}
                  OnChange={ChangeFileSelected}
                  OnRemove={null}
                  image={selectedTextureFile}
                />
              </div>

              {uploadingTextureFile &&
                <div>
                  <label htmlFor="file">Progresso do Upload:</label>
                  <ProgressBar variant="success" now={uploadTexturePercentage} label={`${uploadTexturePercentage}%`} />
                </div>
              }

              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={disabled}
                onClick={e => {
                  e.preventDefault();
                  OnSubmit();
                }}>{creatingNew ?
                  "Adicionar grupo" :
                  "Editar grupo"}
              </button>
            </form>
          </div>
        </main>
      </div>
    </Container >
  )
}